import type { PDFDocument, PDFImage } from 'pdf-lib'
import logoPng from '@/assets/images/logo.png'
import logoFullPng from '@/assets/images/cybsis-logo-full.png'
import buildingPng from '@/assets/images/building.png'
import userPng from '@/assets/images/user.png'
import calendarPng from '@/assets/images/calendar.png'

export interface LoadedImages {
	logoPng: PDFImage
	logoFullPng: PDFImage
	buildingPng: PDFImage
	userPng: PDFImage
	calendarPng: PDFImage
	logoAspect: number
	logoFullAspect: number
}

async function fetchImageData(url: string) {
	const response = await fetch(url)
	return new Uint8Array(await response.arrayBuffer())
}

async function getImageAspect(url: string): Promise<number> {
	const img = new Image()
	img.src = url
	await new Promise((resolve) => (img.onload = resolve))
	return img.naturalWidth / img.naturalHeight
}

export async function loadAllImages(pdfDoc: PDFDocument): Promise<LoadedImages> {
	const [logoData, logoFullData, buildingData, userData, calendarData] = await Promise.all([
		fetchImageData(logoPng),
		fetchImageData(logoFullPng),
		fetchImageData(buildingPng),
		fetchImageData(userPng),
		fetchImageData(calendarPng),
	])

	const [logoAspect, logoFullAspect] = await Promise.all([getImageAspect(logoPng), getImageAspect(logoFullPng)])

	return {
		logoPng: await pdfDoc.embedPng(logoData),
		logoFullPng: await pdfDoc.embedPng(logoFullData),
		buildingPng: await pdfDoc.embedPng(buildingData),
		userPng: await pdfDoc.embedPng(userData),
		calendarPng: await pdfDoc.embedPng(calendarData),
		logoAspect,
		logoFullAspect,
	}
}
